// Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDySWRElVMI6rf4TUdf1jHSQFDFb7-aeVY",
  authDomain: "bb-target-center.firebaseapp.com",
  projectId: "bb-target-center",
  storageBucket: "bb-target-center.appspot.com",
  messagingSenderId: "683719661567",
  appId: "1:683719661567:web:377b37d4f32dd2dedb39ca"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export default app;